import { useNavigate } from 'react-router-dom'
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { Form } from 'semantic-ui-react'
import {
    DangerText,
    LoaderBar,
    ScreenHeight,
    TitleText,
    ImageContainer,
    FlexRowBetween,
} from 'components'
import { AuthService, DefaultText, FormErrorText } from 'utility'
import {
    AppPrimaryButton,
    CommanAuthScreenLogin,
    FormTextFormField,
    FormPasswordFormField,
} from 'elements'
import { useNotification } from 'hooks'
import { Images } from 'assets'
import { useTabletAndBelowMediaQuery } from 'layout'

const SignUpSchema = yup.object().shape({
    FullName: yup.string().trim(FormErrorText.SpacesNotAllowed).required('Full name is required'),
    CompanyName: yup.string().trim(FormErrorText.SpacesNotAllowed).required('Company name is required'),
    Email: yup
        .string()
        .trim(FormErrorText.SpacesNotAllowed)
        .strict()
        .email('Enter a valid email')
        .required('Email is required'),
    Password: yup
        .string()
        .trim('Spaces not allowed')
        .strict()
        .required('Password is required')
        .min(8, 'Password is too short - should be 8 chars minimum.'),
})

export const SignUpScreen = () => {
    const { successToast, errorToasts } = useNotification()
    const navigate = useNavigate()
    const [processing, setProcessing] = useState('')
    const [error, setError] = useState('')
    const isMobile = useTabletAndBelowMediaQuery()
    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(SignUpSchema),
    })

    const submit = async formData => {
        try {
            setProcessing('Processing')
            await AuthService.register(formData)
            successToast('User register success')
            setError('')
            navigate('/sign-in')
        } catch (error) {
            console.log(error)
            setError(DefaultText.defaultError)
            errorToasts(DefaultText.defaultError)
        } finally {
            setProcessing('')
        }
    }

    return (
        <ScreenHeight className="container ">
            <CommanAuthScreenLogin isMobile={isMobile}>
                {processing && <LoaderBar content={processing} />}
                <TitleText>
                    {' '}
                    <ImageContainer src={Images.Logo} className="img" style={{ marginRight: '10px' }} />
                    <span>Sign up for eAuditor</span>
                </TitleText>
                <Form
                    noValidate
                    onSubmit={handleSubmit(submit)}
                    className="mt-5"
                >
                    <FormTextFormField
                        control={control}
                        label="Full Name"
                        name="FullName"
                        placeholder="Full Name"
                        errors={errors?.FullName}
                        defaultValue=""
                    />
                    <FormTextFormField
                        control={control}
                        label="Company Name"
                        name="CompanyName"
                        placeholder="Company Name"
                        errors={errors?.CompanyName}
                        defaultValue=""
                    />
                    <FormTextFormField
                        control={control}
                        label="Email"
                        name="Email"
                        placeholder="Email"
                        errors={errors?.Email}
                        defaultValue=""
                    />
                    <FormPasswordFormField
                        control={control}
                        label="Password"
                        name="Password"
                        placeholder="Password"
                        errors={errors?.Password}
                        defaultValue=""
                        type="password"
                    />
                    {error && <DangerText>{error}</DangerText>}
                    <FlexRowBetween>
                        <AppPrimaryButton fluid className="mt-2">
                            Sign up
                        </AppPrimaryButton>
                        <AppPrimaryButton
                            type="button"
                            fluid
                            basic
                            className="mt-2"
                            onClick={() => navigate('/sign-in')}
                        >
                            Login
                        </AppPrimaryButton>
                    </FlexRowBetween>
                </Form>
            </CommanAuthScreenLogin>
        </ScreenHeight>
    )
}
